/**
 * Auth layout for login page.
 */

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return <div className="auth-page">{children}</div>;
}
